import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
// import jwt_decode from "jwt-decode";
import { retry, catchError } from 'rxjs/operators';
import { TokenStorageService }  from "./token-storage.service";
import { SharedService }  from "./shared.service";
import { IAuthToken } from '../interfaces/auth-token';

@Injectable({
  providedIn: 'root'
})
export class UserAuthService {

  // private userPrivilegesUrl = "/auth/users/{userName}/privileges";
  private userPrivilegesFromTokenUrl = "/auth/privileges/from-token";

  constructor(
    private http: HttpClient,
    private tokenStorageService: TokenStorageService,
    private sharedService: SharedService
  ) { }

  // // Find out the user's privileges
  // findUserPrivileges (userName: string): Observable<string[]> {
  //   let url = this.sharedService.getAuthServerBaseUrl() + this.userPrivilegesUrl.replace('{userName}', userName);
  //   return this.http.get<string[]>(url, {responseType: 'json'})
  //   .pipe(
  //     catchError(this.sharedService.handleError)
  //   )
  // }

  // Find out the user's privileges from the auth token
  public findUserPrivileges(): Observable<string[]> {
    let url = this.sharedService.getAuthServerBaseUrl() + this.userPrivilegesFromTokenUrl;
    return this.http.get<string[]>(url, {responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  // Verify whether the current user is authorized against different claims
  public isUserAuthorized(requiredPrivileges: string[]): Observable<boolean> {
    let isUserAuthorized: boolean = false;
    console.log('isUserAuthorized', 'entered');
    if (this.isTokenValid()) {
      console.log('isUserAuthorized', 'valid token');
      if (this.arePrivilegesGranted(requiredPrivileges)) {
        console.log('isUserAuthorized', 'PrivilegesGranted');
        isUserAuthorized = true;
      }
    }
    console.log('isUserAuthorized - isUserAuthorized', isUserAuthorized);
    return of(isUserAuthorized).pipe(tap((v) => console.log(v)));
  }

  // Verify whether the auth token has not expired yet
  public isTokenValid(): Observable<boolean> {
    let isTokenValid: boolean = false;
    let tokenString: string = this.tokenStorageService.getAuthToken() || '';
    if (tokenString) {
      // let authToken : IAuthToken = jwt_decode(tokenString);
      let authToken: IAuthToken  = this.sharedService.jwtDecode(tokenString);
      const now = new Date();
      var utcEpoch = now.getTime();
      isTokenValid = authToken.exp * 1000 > utcEpoch;
    }
    return of(isTokenValid);
  }

  // Verify that the auth token has required privileges
  public arePrivilegesGranted(requiredPrivileges: string[]): Observable<boolean> {
    let arePrivilegesGranted: boolean = true;
    // Locate cached out user privileges
    let userPrivileges = this.tokenStorageService.getUserPrivileges() || [];
    if (!userPrivileges) {
      arePrivilegesGranted = false;
    }
    // Check out every required privilege making sure it is in the list of user privileges
    requiredPrivileges.forEach(reqPriv => {
        if (userPrivileges.findIndex(item => item == reqPriv) < 0) {
          arePrivilegesGranted = false;
        }
      })
    return of(arePrivilegesGranted);
  }

  // Verify whether the auth token has "OTP requested" claim
  public isOtpRequest(): Observable<boolean> {
    let isOtpRequest: boolean = false;
    let tokenString: string = this.tokenStorageService.getAuthToken() || '';
    if (tokenString) {
      // let authToken : IAuthToken = jwt_decode(tokenString);
      let authToken: IAuthToken  = this.sharedService.jwtDecode(tokenString);
      isOtpRequest =  authToken.otps ? true : false;
    }
    return of(isOtpRequest);
  }

  // Verify whether the auth token has "OTP verified" claim
  public isOtpValid(): Observable<boolean> {
    let isOtpValid: boolean = false;
    let tokenString: string = this.tokenStorageService.getAuthToken() || '';
    if (tokenString) {
      // let authToken : IAuthToken = jwt_decode(tokenString);
      let authToken: IAuthToken  = this.sharedService.jwtDecode(tokenString);
      isOtpValid =  authToken.otpv == true ? true : false;
    }
    return of(isOtpValid);
  }

}
